var mp = mp || {};

// Form validation
//----------------------------------------------------------
mp.formContact = function() {
    var $form = $('#form-contact');
        $submitBtn = $form.find('button.btn');

    if (!$form.length) {
        return;
    }

    $form.validate({
        rules: {
            "first_name": {
                required: true,
                minlength: 2
            },
            "last_name": {
                required: true,
                minlength: 2
            },
            "email": {
                required: true,
                email: true
            },
            "phone": {
                required: true,
                minlength: 6
            },
            "message": {
                required: true,
                minlength: 10
            },
        },
        errorPlacement: function(error, element) {
            //element.addClass("test");
        },

        invalidHandler: function(event, validator) {
            // $submitBtn.toggleClass('disabled');
        },

        highlight: function(element, errorClass, validClass) {
            $(element).addClass(errorClass);
            $(element).parents('.form__group').addClass(errorClass);
        },

        unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass(errorClass);
            $(element).parents('.form__group').removeClass(errorClass);
        },

        submitHandler: function(form) {
            var $formData = new FormData(form);

            $.ajax({
                url: form.action,
                type: form.method,
                data: $(form).serialize(),
                success: function(response) {
                    response = jQuery.parseJSON(response);

                    $form.html("<div class='form__group form__group--full'><h4>"+response.msg+"</h4></div>");
                    
                    $('html, body').animate({
                        scrollTop: $form.offset().top
                    }, 800);
                }           
            });

        }
    });
};




$(document).ready(function (){
    mp.formContact();
});